import React from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Button from "@amzn/meridian/button";
import Select, {SelectOption} from "@amzn/meridian/select";
import SearchField from "@amzn/meridian/search-field";
import Text from "@amzn/meridian/text";
import {chainWalk} from "../util/Util";

const SearchFilterBar = ({filters, onFiltersChange, filterColumns}) => {

    const activeKeys = filters.map(f => f.key);

    const getAvailableColumns = (currentKey) => {
        return filterColumns.filter(col => col.key === currentKey || !activeKeys.includes(col.key));
    };

    const updateFilter = (index, field, value) => {
        const updated = [...filters];
        if (field === 'key') {
            updated[index] = {key: value, value: ''};
        } else {
            updated[index] = {...updated[index], value};
        }
        onFiltersChange(updated);
    };

    const addFilter = () => {
        const available = filterColumns.filter(col => !activeKeys.includes(col.key));
        if (available.length > 0) {
            onFiltersChange([...filters, {key: available[0].key, value: ''}]);
        }
    };

    const removeFilter = (index) => {
        onFiltersChange(filters.filter((_, i) => i !== index));
    };

    const canAddFilter = filterColumns.filter(col => !activeKeys.includes(col.key)).length > 0;

    // A column may supply a hint to use in place of its label in the placeholder, for columns whose
    // valid values are not obvious from the label alone.
    const getPlaceholderText = (key) => chainWalk(() => {
        const column = filterColumns.find(col => col.key === key);
        return column.hint || column.label;
    }, '');

    return (
        <Row wrap="down" spacing="small" alignmentVertical="bottom">
            {filters.map((filter, index) => (
                <Row key={filter.key} spacing="xsmall" alignmentVertical="bottom">
                    <Column spacing="xsmall">
                        {index === 0 && <Text type="b200">Search</Text>}
                        <Select
                            value={filter.key}
                            onChange={(value) => updateFilter(index, 'key', value)}
                            size="small"
                            width={140}
                        >
                            {getAvailableColumns(filter.key).map(col => (
                                <SelectOption key={col.key} value={col.key} label={col.label}/>
                            ))}
                        </Select>
                    </Column>
                    <Column spacing="xsmall">
                        {index === 0 && <Text type="b200">&nbsp;</Text>}
                        <SearchField
                            value={filter.value}
                            onChange={(value) => updateFilter(index, 'value', value)}
                            onSubmit={() => {}}
                            placeholder={`Filter by ${getPlaceholderText(filter.key)}...`}
                            size="small"
                        />
                    </Column>
                    {index > 0 && (
                        <Button type="tertiary" size="small" onClick={() => removeFilter(index)}>
                            ✕
                        </Button>
                    )}
                </Row>
            ))}
            {canAddFilter && (
                <Button type="tertiary" size="small" onClick={addFilter}>
                    + Add Filter
                </Button>
            )}
        </Row>
    );
};

export default SearchFilterBar;



// WEBPACK FOOTER //
// ./src/components/commonui/SearchFilterBar.js